export const languageUrls = [
    {
        en: 'termsandconditions',
        ru: 'pravilaiuslovia',
        ka: 'wesebidapirobebi'
    },
    {
        en: 'salespoints',
        ru: 'tochkiprodaji',
        ka: 'gayidviswertilebi'
    },
    {
        en: 'aboutus',
        ru: 'onas',
        ka: 'CvenSesaxeb'
    },
    {
        en: 'faq',
        ru: 'faq',
        ka: 'faq'
    },
    {
        en: 'contactus',
        ru: 'kontakt',
        ka: 'kontaqti'
    },
    {
        en: 'categorydescription',
        ru: 'opisaniekategorii',
        ka: 'kategoriisagtsera'
    },
    {
        en: 'productdetails',
        ru: 'detaliprodukta',
        ka: 'produqtisdetalebi'
    },
    {
        en: 'policies',
        ru: 'polici',
        ka: 'polisebi'
    }
]






//     categorydescription 
//     productdetails 
//     salespoints  
//     faq 
//     aboutus 
//     contactus 
//     termsandconditions 
//     policies 
//     policies /: policiesId /: status 
//     searchResult
// 


// WEBPACK FOOTER //
// ./src/components/languageUrls.js